import general from "../../../utils/general";
import requestService from "../../../services/request-service";
import {toast} from "react-toastify";
import {AlertMessage} from "../../../utils/alert-message";
import {statusList} from "../resources/status-list";

export const saveData = (data, onFilterChanged, queryClient) => {
    const form = {
        date: general.formatDateToSave(data.date),
        deadline: general.formatDateToSave(data.deadline),
        title: data.title,
        exec_order: data.exec_order,
        projects: JSON.stringify(data.projects.map(p => p.id)),
        devs: JSON.stringify(data.devs.map(d => d.id)),
        groups: JSON.stringify(data.groups.map(g => g.id)),
        status: statusList.find(s => s.value.toUpperCase() === data?.status?.toUpperCase())?.value ?? null,
        responsible_id: data.responsible?.id ?? null,
        _method: 'PUT',
    }

    requestService.edit(form, data.id)
        .then(() => {
            // toast.success("Salvo com sucesso.");
            if (onFilterChanged) onFilterChanged();
            if (!data.groups || !data.projects || !data.devs) queryClient.invalidateQueries(["requests"]);
        })
        .catch((err) => {
            const {data: {message}} = err.response;
            toast.error(AlertMessage[message] ?? "Não foi possível salvar");
        });
}